/* Outlands — global theme behaviour */
(function () {
  function revealAll() {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
  function init() {
    var els = document.querySelectorAll('.reveal');
    // Fail-safe: if IntersectionObserver is unavailable, just show everything.
    if (!('IntersectionObserver' in window) || !els.length) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: reveal anything still hidden after 3s (e.g. design-mode reflows).
    setTimeout(revealAll, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
